import React, { FC, lazy, Suspense } from 'react';
import Spinner from '@fenderdigital/ui/Spinner';
import useFenderConnect from '@fenderdigital/custom-hooks/hooks/useFenderConnect';
import { getFlag } from '../../lib/feature-flags';

const SubscribedLayout = lazy((/* webpackChunkName: "SubscribedLayout" */) =>
  import('../SubscribedLayout'));
const UnSubscribedLayout = lazy((/* webpackChunkName: "UnSubscribedLayout" */) =>
  import('../UnSubscribedLayout'));

const Chrome: FC = ({ children }) => {
  const { hasSubscription, sessionCheckComplete, loggedIn } = useFenderConnect();
  const isPlayAuthRedirectEnabled = getFlag('isPlayAuthRedirectEnabled');

  if (!sessionCheckComplete)
    return <Spinner fullPage strokeBaseColor="black" strokeColor="transparent" />;

  return (
    <Suspense fallback={<Spinner fullPage strokeBaseColor="black" strokeColor="transparent" />}>
      {isPlayAuthRedirectEnabled ? (
        children
      ) : (
        <>
          {hasSubscription && loggedIn ? (
            <SubscribedLayout>{children}</SubscribedLayout>
          ) : (
            <UnSubscribedLayout>{children}</UnSubscribedLayout>
          )}
        </>
      )}
    </Suspense>
  );
};

export default Chrome;
